import { ShoppingBasket } from "lucide-react";
import React from "react";

import { useFitCheckBasket } from "@/app/context/FitCheckBasket";

interface FitCheckBasketIconProps {
	onClick?: () => void;
	className?: string;
}

function FitCheckBasketIcon({ onClick }: FitCheckBasketIconProps) {
	const { basketCount } = useFitCheckBasket();

	if (basketCount === 0) {
		return null;
	}

	return (
		<button
			onClick={onClick}
			className="relative inline-flex items-center justify-center bg-primary-700 rounded-full p-4 shadow-md"
			aria-label={`FitCheck basket with ${basketCount} items`}
		>
			{/* Main circle with basket icon */}
			<ShoppingBasket className="w-6 h-6 text-white" strokeWidth={1.5} />

			{/* Count badge */}
			<div
				className="absolute right-0 min-w-[24px] shadow-lg h-6 bg-white rounded-full flex items-center justify-center aspect-square border border-gray-100"
				style={{
					top: "-8px",
				}}
			>
				<span className="text-sm font-semibold text-gray-900 px-1">{basketCount}</span>
			</div>
		</button>
	);
}

export default FitCheckBasketIcon;
